import PodcastsAsset from '../playlist/PodcastsAsset'

export default class PodcastListAsset {
  constructor(obj) {
    this.podcasts = []
    this.podcastHeroes = []
    this._blocks = []

    this.title = obj.title
    this.type = 'podcasts'

    if (obj && obj.heroBlock) {
      this.HeroSlug = obj.heroBlock.slug
      this.HeroTitle = obj.heroBlock.title
      this.Herotype = 'PodcastHero'
    }

    if (obj && obj.heroBlock && obj.heroBlock.items && obj.heroBlock.items.length > 0) {
      this.podcastHeroes = new PodcastsAsset(obj.heroBlock, 'podcast')
    }

    if (obj && obj.blocks && obj.blocks.length > 0) {
      this.podcasts = obj.blocks.map(blck => {
        return new PodcastsAsset(blck, 'podcast')
      })
    }
  }

  get blocks() {
    this._blocks = [this.podcastHeroes]
    this._blocks = [...this._blocks, ...this.podcasts]

    return this._blocks
  }
}
